import React from "react";

const QuoteStepHeading = ({
  title,
  description,
  className = "tw-mb-[30px]",
  titleClassName = "",
  mobileTitleClassName = "max-sm:tw-text-2xl",
  descriptionClassName,
}) => (
  <div className={className}>
    <h1
      className={`tw-m-0 ${description ? "tw-mb-2" : ""} tw-text-dis-navy tw-text-3xl ${mobileTitleClassName} ${titleClassName}`}
    >
      {title}
    </h1>
    {description && (
      <p
        className={`tw-m-0 tw-text-dis-small tw-text-dis-text-muted ${descriptionClassName ||
          ""}`}
      >
        {description}
      </p>
    )}
  </div>
);

export default QuoteStepHeading;
